/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import styled from 'styled-components';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import { FooterOkBtn } from 'components/footer/Footer.styled';

const PricingTable = styled.div`
  max-width: 200px !important;
  > div {
    display: flex;

    flex-direction: row;
    align-content: space-between;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: nowrap;
  }
`;

const PricingDescription = styled.p`
  font-family: inherit;
  margin-top: 10px;
  color: #656a66;
  margin-bottom: 24px;
`;

const Check = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const totalToPay = parseFloat(localStorage.getItem('totalToPay')).toFixed(2);

  const handleSubmit = async () => {
    if (!stripe || !elements) {
      return;
    }
    await stripe
      .confirmPayment({
        elements,
        redirect: 'if_required',
      })
      .then(function (result) {
        if (result.paymentIntent) {
          console.log(result.paymentIntent.payment_method);
          localStorage.setItem('payment', result.paymentIntent.payment_method);
          setIsSuccessful(true);
          props.onConfirm();
        } else {
          setErrorMessage('Error');
        }
      });
  };

  if (isSuccessful) {
    return (
      <h3>
        Excellent, now continue with the process, you won’t be charged until
        you’re contacted by one of our representatives and the appointment is
        confirmed.
      </h3>
    );
  }
  return (
    <div>
      <hr />
      <PricingTable>
        <div>
          <strong>Service fee:</strong>
          <span>$90.00</span>
        </div>
        <div>
          <strong>Mileage fee:</strong>
          <span>${(totalToPay - 90).toFixed(2)}</span>
        </div>
        <div>
          <strong>Total:</strong>
          <span>${totalToPay}</span>
        </div>
      </PricingTable>

      <PricingDescription>
        We’re collecting your Credit Card information however, you won’t be
        charged until you’re contacted by one of our representatives and the
        appointment is confirmed.
        <br />A Cancellation fee of 50% the total amount will apply if
        appointment is cancelled within 24 hours of the visit, or 100% if it is
        a no-show, or cancellation is at the time of the appointment.
      </PricingDescription>
      <br />
      <PaymentElement />
      <br />
      <br />
      <FooterOkBtn disabled={!stripe} onClick={() => handleSubmit()}>
        Continue
      </FooterOkBtn>
      {errorMessage && <div>{errorMessage}</div>}
    </div>
  );
};

export default Check;
